import { useEffect, useState } from 'react';
import useIsHybridPathway from 'hooks/use-is-hybrid-pathway';
import { defaultSpaceOpacity } from 'utils/space-opacity';

export default function useSpaceOpacity() {
  const isHybridPathway = useIsHybridPathway();
  const pathwayDefault = defaultSpaceOpacity(isHybridPathway);
  const [spaceOpacity, setSpaceOpacity] = useState(pathwayDefault);

  useEffect(() => {
    setSpaceOpacity(pathwayDefault);
  }, [pathwayDefault]);

  return [spaceOpacity, setSpaceOpacity] as const;
}
